<template>
  <nav id="site-navigation" class="has-branding main-navigation nav-align-right sub-menu-right" aria-label="Primary"
    itemtype="https://schema.org/SiteNavigationElement" itemscope>
    <div class="inside-navigation">
      <a class="navigation-branding brand-link" href="/" title="GB Apps" rel="home">
        <img class="header-image is-logo-image" alt="GB Apps" :src="logoSrc" title="GB Apps" width="40" height="40">
        <span id="webName" class="brand-name">{{ $siteName || 'GB Apps' }}</span>
      </a>

      <!-- 移动端展开菜单 -->
      <ul v-show="isMenuClicked" id="menu-primary-menu" class="menu sf-menu mobile-menu-page">
        <li class="menu-item">
          <a href="/" :class="{ active: isActive('home') }" :aria-current="isActive('home') ? 'page' : null">Home</a>
        </li>
        <li id="downloadLink" class="menu-item">
          <a href="/download/" class="download-btn" :class="{ active: isActive('download') }" :aria-current="isActive('download') ? 'page' : null">Download</a>
        </li>
        <li class="menu-item">
          <a href="/old-versions/" :class="{ active: isActive('old-versions') }" :aria-current="isActive('old-versions') ? 'page' : null">Old Versions</a>
        </li>
        <li class="menu-item">
          <a href="/for-pc/" :class="{ active: isActive('for-pc') }" :aria-current="isActive('for-pc') ? 'page' : null">For PC</a>
        </li>
        <li class="menu-item">
          <a href="/blog/" :class="{ active: isActive('blog') }" :aria-current="isActive('blog') ? 'page' : null">Blog</a>
        </li>
      </ul>

      <div id="primary-menu" class="main-nav">
        <div v-if="$global.isMobileDevice()" class="mobile-menu">
          <div class="menu-toggle" @click="isMenuClicked = !isMenuClicked">
            <img v-if="!isMenuClicked" src="@/assets/menu.svg" alt="menu button">
            <img v-else src="@/assets/xmark-black.svg" alt="close button">
          </div>
        </div>
        <div v-else id="menu-primary-menu" class="desktop-menu">
          <div id="homeLink">
            <a href="/" :class="{ active: isActive('home') }" :aria-current="isActive('home') ? 'page' : null">Home</a>
          </div>
          <div id="downloadLink">
            <a href="/download/" class="download-btn" :class="{ active: isActive('download') }" :aria-current="isActive('download') ? 'page' : null">Download</a>
          </div>
          <div id="oldVersionLink">
            <a href="/old-versions/" :class="{ active: isActive('old-versions') }" :aria-current="isActive('old-versions') ? 'page' : null">Old Versions</a>
          </div>
          <div id="forPcLink">
            <a href="/for-pc/" :class="{ active: isActive('for-pc') }" :aria-current="isActive('for-pc') ? 'page' : null">For PC</a>
          </div>
          <div id="blogLink">
            <a href="/blog/" :class="{ active: isActive('blog') }" :aria-current="isActive('blog') ? 'page' : null">Blog</a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  props: {
    selectedLanguage: {
      type: String,
      default: 'en',
    },
    page: {
      type: String,
      required: true,
    },
    gotodownload: {
      type: Function,
    },
    apk: {
      type: Object,
    },
  },
  data() {
    return {
      isMenuClicked: false,
      logoSrc: require('@/assets/logo-gb.png'),
    }
  },
  computed: {
    // 根据当前路径判断选中项
    activeKey() {
      const path = ((this.$route && this.$route.path) || '/').replace(/\/+$/, '') || '/'
      if (path === '/' || path === '') return 'home'
      if (path.startsWith('/download')) return 'download'
      if (path.startsWith('/old-versions')) return 'old-versions'
      if (path.startsWith('/for-pc')) return 'for-pc'
      if (path.startsWith('/blog')) return 'blog'
      if (
        [
          '/restore-gb-whatsapp-chats-after-reinstalling',
          '/transfer-gb-whatsapp-chats-to-new-phone',
          '/gb-whatsapp-temporary-ban',
        ].includes(path)
      ) {
        return 'blog'
      }
      return ''
    },
  },
  methods: {
    isActive(key) {
      return this.activeKey === key
    },
  },
}
</script>

<style lang="scss" scoped>
.inside-navigation {
  width: min(980px, 88vw);
  margin: 0 auto;
  padding: 12px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.brand-link {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-right: auto;
  text-decoration: none !important;
  color: #15803d !important;
}

.brand-name,
#webName {
  color: #15803d !important;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0.01em;
  line-height: 1;
  white-space: nowrap;
}

.header-image.is-logo-image {
  display: block;
  width: 36px;
  height: 36px;
  padding: 0 !important;
  margin: 0;
  border-radius: 10px;
  object-fit: contain;
  background: transparent;
}

.desktop-menu {
  display: flex;
  align-items: center;
  gap: 4px;

  a {
    color: #334155;
    text-decoration: none;
    padding: 8px 12px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 999px;
    transition: color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
  }

  a:hover {
    color: #15803d;
    background: #eaf7f3;
  }

  /* 普通菜单选中高亮 */
  a.active:not(.download-btn) {
    color: #15803d;
    background: #eaf7f3;
    box-shadow: inset 0 0 0 1px #86efac;
  }

  .download-btn {
    color: #fff !important;
    background: linear-gradient(180deg, #34d399, #16a34a);
    border-radius: 999px;
    padding: 8px 16px;
    box-shadow: 0 6px 14px rgba(22, 163, 74, 0.22);
  }

  .download-btn:hover {
    color: #fff !important;
    background: linear-gradient(180deg, #22c55e, #15803d);
  }

  /* Download 选中时加深，并加外圈 */
  .download-btn.active {
    background: linear-gradient(180deg, #22c55e, #15803d);
    box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.25), 0 6px 14px rgba(22, 163, 74, 0.28);
  }
}

.mobile-menu-page {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  z-index: 20;
  margin: 0;
  padding: 8px;
  list-style: none;
  background: #f7fdf9;
  border-bottom: 1px solid #d7ebe5;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);

  a {
    display: block;
    padding: 12px 16px;
    color: #0f172a;
    text-decoration: none;
    font-size: 14px;
    font-weight: 600;
    border-radius: 10px;
  }

  a:hover {
    background: #eaf7f3;
    color: #15803d;
  }

  a.active:not(.download-btn) {
    color: #15803d;
    background: #eaf7f3;
    box-shadow: inset 0 0 0 1px #86efac;
  }

  .download-btn {
    color: #fff !important;
    background: linear-gradient(180deg, #34d399, #16a34a);
    text-align: center;
  }

  .download-btn.active {
    background: linear-gradient(180deg, #22c55e, #15803d);
    box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.35);
  }
}
</style>
